import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'inArray'})
export class InArrayPipe implements PipeTransform  {

    constructor() { }

    transform(values: Array<string>, item: string): boolean {
        return values.indexOf(item) !== -1;
    }
}
